module.exports = __webpack_public_path__ + "static/media/con_mag.2611a7fa.png";